<template>
  <div
    :class="_.swiper"
    :style="{
      '--title-color': theme.titleFontColor,
      '--subtitle-color': theme.subTitleFontColor,
    }"
  >
    <div v-if="theme.titleType !== 'none'" :class="_.hd">
      <img
        v-if="theme.titleType === 'url'"
        :src="theme.title"
        :class="_.image"
        @click="
          theme.hasJumpButton &&
            $router.push(`/diy/list/index?componentId=${componentId}`)
        "
      />
    </div>
    <div :class="_.bd">
      <div
        v-for="(item, index) in data"
        :key="index"
        v-track="{
          name: '文章列表-文章',
          id: `DianJiZiDingYiYeZiYuan`,
          resource: item,
          index: index,
          extra: getTrackExtra(item, index),
        }"
        :class="[_.item, index > 0 && 'van-hairline--top']"
        @click="$dmbcResourceClick(item)"
      >
        <img :src="item.icon" :class="_.cover" />
        <div :class="_.content">
          <div :class="_.title">{{ item.title }}</div>
          <div :class="_.desc">{{ item.subTitle }}</div>
          <div :class="_.grow"></div>
          <div :class="_.time">{{ item.extendData.createDate }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({})
</script>

<style lang="scss" module="_">
  .swiper {
    border-radius: var(--border-radius);
    font-size: 0;

    .hd {
      .image {
        width: 100%;
        height: auto;
      }
    }

    .bd {
      padding: var(--padding-top) var(--padding-right) var(--padding-bottom)
        var(--padding-left);

      .item {
        display: flex;
        align-items: stretch;

        .cover {
          flex-shrink: 0;
          width: 80px;
          height: 60px;
          object-fit: cover;
          border-radius: 6px;
        }

        .content {
          flex-grow: 1;
          margin-left: 12px;
          display: flex;
          flex-direction: column;
          overflow: hidden;

          .title {
            font-size: 14px;
            font-weight: bold;
            color: var(--title-color, #333333);
            line-height: 20px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .desc {
            font-size: 12px;
            color: var(--subtitle-color, #999999);
            line-height: 17px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .grow {
            flex-grow: 1;
          }

          .time {
            font-size: 12px;
            color: #999999;
            line-height: 17px;
          }
        }

        + .item {
          margin-top: 12px;
          padding-top: 12px;
        }
      }
    }
  }
</style>
